import LoginConstants from '../../constants/Login/LoginConstants.js';
import emergencyContact, { DEFAULT_STATE as EMERGENCY_CONTACT_DEFAULT_STATE } from './emergencyContact.js';
import merge, { DEFAULT_STATE as MERGE_DEFAULT_STATE } from './merge.js';
import occupations, { DEFAULT_STATE as OCCUPATIONS_DEFAULT_STATE } from './occupations.js';
import personCache, { DEFAULT_STATE as PERSON_CACHE_DEFAULT_STATE } from './personCache.js';

const DEFAULT_STATE = {
    emergencyContact: EMERGENCY_CONTACT_DEFAULT_STATE,
    groups: [], // small groups person of which person is a member
    merge: MERGE_DEFAULT_STATE,
    ministries: [], // ministries of which person is a member
    occupations: OCCUPATIONS_DEFAULT_STATE,
    personCache: PERSON_CACHE_DEFAULT_STATE,
    record: {}, // result of a query for a single person record
    searchFields: [],
};

export default function (state = DEFAULT_STATE, action) {
    switch (action.type) {
        case LoginConstants.LOGOUT: // reset all stores on logout
            return DEFAULT_STATE;

        case 'PersonActions.ON_GET':
            return {
                ...state,
                record: action.result,
            };

        case 'PersonActions.ON_GETGROUPS':
            return {
                ...state,
                groups: action.result,
            };

        case 'PersonActions.ON_GETMINISTRIES':
            return {
                ...state,
                ministries: action.result,
            };

        case 'PersonActions.RESET':
            return {
                ...state,
                groups: [],
                ministries: [],
                record: {},
            };

        case 'PersonActions.ON_GETSEARCHFIELDS':
            return {
                ...state,
                searchFields: action.result,
            };

        case 'PersonMergeActions.ON_GETPEOPLE':
            return {
                ...state,
                merge: merge(state.merge, action),
            };

        case 'OccupationActions.RESET':
        case 'OccupationActions.ON_GET':
        case 'OccupationActions.ON_CREATE':
        case 'OccupationActions.ON_UPDATE':
        case 'OccupationActions.ON_DELETE':
        case 'OccupationActions.ON_REQUESTAUDITNOTE':
        case 'OccupationActions.ON_CLEARNOTEREQUEST':
            return {
                ...state,
                occupations: occupations(state.occupations, action),
            };

        case 'PersonCacheActions.ON_GET':
        case 'PersonCacheActions.ON_RESET':
            return {
                ...state,
                personCache: personCache(state.personCache, action),
            };

        case 'PersonEmergencyContactActions.ON_SET_IS_DRAWER_OPEN':
            return {
                ...state,
                emergencyContact: emergencyContact(state.emergencyContact, action),
            };

        default:
            return state;
    }
}
